import { darken, IconButton, Stack, Theme, useTheme } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useSwiper } from "swiper/react";
import React, { useState } from "react";
import Swiper from "swiper";

export function useSwiperInstance() {
  const swiperCtx = useSwiper();
  const [swiper, setSwiper] = useState<Swiper | null>(null);
  return { swiper: swiperCtx || swiper, setSwiper };
}

export const SwiperNavigation = {
  Anchored: AnchoredSwiperNav,
  Overlayed: OverlayedSwiperNav,
};

function AnchoredSwiperNav(props: { swiper?: Swiper }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Stack
      id={"anchored-swiper-nav"}
      spacing={1}
      direction={"row"}
      alignItems={"center"}
      bgcolor={theme.palette.background.default}
    >
      <IconButton
        size="medium"
        sx={{ ...styles.iconButton }}
        onClick={() => props?.swiper?.slidePrev()}
      >
        <ArrowBackIosNewRoundedIcon />
      </IconButton>
      <IconButton
        size="medium"
        sx={{ ...styles.iconButton }}
        onClick={() => props?.swiper?.slideNext()}
      >
        <ArrowForwardIosRoundedIcon />
      </IconButton>
    </Stack>
  );
}

export type OverlayedSwiperNavProps = {
  // offset props to manually adjust the position of the buttons
  prevButton?: {
    offsetTop?: number;
    offsetLeft?: number;
  };
  nextButton?: {
    offsetTop?: number;
    offsetRight?: number;
  };
};

function OverlayedSwiperNav(props: OverlayedSwiperNavProps) {
  const { swiper } = useSwiperInstance();
  const theme = useTheme();
  const styles = useStyles(theme, props);

  return (
    <>
      <IconButton
        size="medium"
        sx={{
          ...styles.overlayedIconButton,
          ...styles.overlayedPrevIconButton,
        }}
        onClick={() => swiper?.slidePrev?.()}
      >
        <ArrowBackIosNewRoundedIcon fontSize="small" />
      </IconButton>
      <IconButton
        size="medium"
        sx={{
          ...styles.overlayedIconButton,
          ...styles.overlayedNextIconButton,
        }}
        onClick={() => swiper?.slideNext?.()}
      >
        <ArrowForwardIosRoundedIcon fontSize="small" />
      </IconButton>
    </>
  );
}

function useStyles(theme: Theme, props?: OverlayedSwiperNavProps) {
  return {
    iconButton: {
      outline: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
    },

    overlayedIconButton: {
      // border: `1px solid ${theme.palette.divider}`,
      width: "42px",
      height: "42px",
      padding: "4px",
      backgroundColor: `rgba(0, 0, 0, 0.4)`,
      transition: "all 0.15s ease-in-out",
      transform: "translateY(-50%)",
      "&:hover": { backgroundColor: `rgba(0, 0, 0, 0.6)` },
      borderRadius: "50%",
      position: "absolute",
      zIndex: 999,
      top: "50%",
      color: `rgba(255, 255, 255, 0.7)`,
    },

    overlayedPrevIconButton: {
      left: `calc(0px + ${props?.prevButton?.offsetLeft || 0}px)`,
      top: `calc(50% + ${props?.prevButton?.offsetTop || 0}px)`,
    },
    overlayedNextIconButton: {
      right: `calc(0px + ${props?.nextButton?.offsetRight || 0}px)`,
      top: `calc(50% + ${props?.nextButton?.offsetTop || 0}px)`,
    },
  };
}
